import { isNil, Nillable } from '@web/utils';
import { TableFilter } from '../../collection/types/table-filter';
import { CollectionFilterKey } from '../../collection/types/collection-filter-key';
import { CollectionFilterOperator } from '../enums/collection-filter-operator';
import { CollectionFilterRequest } from '../requests/collection-filter.request';
import { RequiredMethodCallException } from '../../exceptions/required-method-call.exception';
import { CollectionFilterValue } from '../../collection/types/collection-filter-value';

export abstract class FromTableBaseCollectionFilterRequestBuilder<Filter> {
  protected _operator: Nillable<CollectionFilterOperator>;
  protected _value: Nillable<CollectionFilterValue>;
  protected _property: Nillable<CollectionFilterKey<Filter>>;
  protected _filter: Nillable<TableFilter<Filter>>;

  public fromTableFilter(filter: TableFilter<Filter>): this {
    this._filter = filter;

    return this;
  }

  public property(property: CollectionFilterKey<Filter>): this {
    this._property = property;

    return this;
  }

  public reset(): this {
    this._operator = null;
    this._value = null;
    this._property = null;
    this._filter = null;

    return this;
  }

  public build(): Nillable<CollectionFilterRequest> {
    this.validate();

    this._value = this._filter![this._property]?.value;

    if (isNil(this._value)) {
      this.reset();

      return null;
    }

    const result = new CollectionFilterRequest(
      this._property! as string,
      this._value!,
      this._operator!,
    );

    this.reset();

    return result;
  }

  protected validate(): void {
    this.requireProperty();
  }

  protected operator(operator: CollectionFilterOperator): this {
    this._operator = operator;

    return this;
  }

  protected requireProperty(): void {
    if (isNil(this._property)) {
      throw new RequiredMethodCallException(this.property.name);
    }
  }
}
